<template>
  <div class="select-component relative bg-white inline-block rounded w-32 text-sm">
    <div class="selected-item w-full flex justify-between items-center bg-white border border-gray-300 px-3 py-2 rounded cursor-pointer focus:outline-none focus:border-gray-400" @click="toggleDropdown">
      {{ selectedOption.label }}
      <i class="icon-arrow-down inline-block float-right"></i>
    </div>
    <ul v-show="isOpen" class="options absolute rounded mt-2">
      <li
        v-for="(option, index) in options"
        :key="index"
        class="bg-white focus:bg-gray-200 px-3 py-2 cursor-pointer hover:text-secondary hover:bg-gray-200 hover:font-bold"
        @click="selectOption(option)"
      >
        {{ option.label }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: String | Number, default: ''},
    options: { type: Array, default: () => [] }
  },
  data() {
    return {
      isOpen: false,
      selectedValue: this.value
    };
  },
  computed: {
    selectedOption () {
      return this.options.find(opt => (this.selectedValue == opt.value));
    }
  },
  watch: {
    value(newValue) {
      this.selectedValue = newValue;
    }
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    selectOption(option) {
      this.selectedValue = option.value;
      this.isOpen = false;
      this.$emit('input', option.value);
      this.$emit('change', option.value);
    }
  }
};
</script>

<style lang="scss" scoped>
.select-component {
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);

}

.options {
  min-width: 100%;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 999;
}

.options li {
  &:first-child {
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
  }

  &:last-child {
    border-bottom-left-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
  }
}

</style>